import { CustomDropdownBoxButton } from "../button/CustomDropdownBoxButton";
import Translate from "../../translate/Translate";

export default function UserManagementButton({ currentValue, setValue }) {
    const values = [
        { label: Translate("common.allStatus"), value: "all" },
        { label: Translate("userManagement.status.pending"), value: "N" },
        { label: Translate("userManagement.status.reject"), value: "C" },
        { label: Translate("userManagement.status.approve"), value: "Y" },
    ];

    return (
        <CustomDropdownBoxButton
            icon={currentValue === "all" ? "filter" : "filter_active"}
            currentValue={currentValue}
            setValue={setValue}
            values={values}
        />
    );
}
